import { createContext } from 'react';

import { useSystemSettings } from 'hooks/useSystemSettings';

export const SystemSettingsContext = createContext<{
  isLoading: boolean;
  data: Record<string, any>;
}>({
  data: {},
  isLoading: false,
});

export const SystemSettingsProvider = ({
  token,
  children,
  tenantName,
  isRootLogin,
}) => {
  const { data, isLoading } = useSystemSettings({
    token,
    tenantName,
    isRootLogin,
  });

  return (
    <SystemSettingsContext.Provider
      value={{
        data,
        isLoading,
      }}
    >
      {children}
    </SystemSettingsContext.Provider>
  );
};
